/**
 * O NOME DE CADA EVENTO em português, para a tela da ponte.
 *
 * O nome técnico (`whatsapp.inbound_received`) é o contrato entre os dois
 * sistemas e não muda; ele só não é o que a pessoa lê. O teste confere que
 * TODO evento do contrato tem rótulo aqui: evento novo sem nome apareceria na
 * tela como código, e ninguém abre um chamado por isso, apenas desconfia do
 * relatório inteiro.
 */
export const NOME_DO_EVENTO: Record<string, string> = {
  // O Notes manda
  "meeting.scheduled": "Reunião agendada",
  "meeting.recorded": "Reunião gravada",
  "meeting.completed": "Reunião analisada",
  "meeting.scored": "Nota da conversa",
  "commitment.created": "Promessa registrada",
  "commitment.fulfilled": "Promessa cumprida",
  "commitment.overdue": "Promessa vencida",
  "objection.detected": "Objeção do cliente",
  "competitor.detected": "Concorrente citado",
  "next_step.missing": "Sem próximo passo",
  "traveler_profile.updated": "Perfil do viajante",
  "document.received": "Documento recebido",
  "deal.risk_signal": "Sinal de risco",
  "action.requested": "Ação aprovada aqui",
  "call.started": "Ligação atendida",
  "call.completed": "Ligação encerrada",
  "call.missed": "Ligação perdida",
  "call.recorded": "Ligação gravada",
  "voicemail.received": "Recado no correio de voz",
  // O CRM manda
  "contact.upserted": "Contato criado ou mudado",
  "deal.upserted": "Negociação criada ou mudada",
  "deal.stage_changed": "Mudança de etapa",
  "deal.won": "Negociação ganha",
  "deal.lost": "Negociação perdida",
  "task.created": "Tarefa criada",
  "task.completed": "Tarefa concluída",
  "proposal.sent": "Proposta enviada",
  "note.created": "Anotação na negociação",
  "whatsapp.inbound_received": "Mensagem de WhatsApp",
  "action.completed": "Ação aplicada no CRM",
  "action.rejected": "Ação recusada pelo CRM",
};

export const nomeDoEvento = (evento: string): string => NOME_DO_EVENTO[evento] ?? evento;
